import type {SVGProps} from 'react';
import * as React from 'react';
export const CardIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 24 24"
		{...props}
	>
		<path
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.8}
			d="M1 9.704h22M5.889 15h3.667M3.444 4h17.112S23 4 23 6.444v11.408s0 2.444-2.444 2.444H3.444S1 20.296 1 17.852V6.444S1 4 3.444 4Z"
		/>
	</svg>
);
